<template>
  <div class="modalWrapper visible" :style="modalVisible ? '': 'display: none'">
    <a href="#" class="bt_modalClose"/>
    <div id="modal_sharing" class="modal" style="">
      <a href="#" class="bt_modalClose" @click.prevent="closeModal"><i class="fa fa-times"/></a>
      <div class="modalHeader">
        <h3>{{ $t('sharingModal.share') }}</h3>
      </div>
      <div class="modalContent">
        <ul class="sharing">
          <li>
            <a :href="whatsappUrl" target="_blank">
              <i class="fab fa-whatsapp"/><span class="tooltip">{{$t('sharingModal.whatsapp')}}</span>
            </a>
          </li>
          <li>
            <a :href="xUrl" target="_blank" >
              <i class="fa-brands fa-x-twitter"/><span class="tooltip">{{$t('sharingModal.twitter')}}</span>
            </a>
          </li>
          <li>
            <a :href="facebookUrl" target="_blank" >
              <i class="fab fa-facebook-f"/><span class="tooltip">{{$t('sharingModal.facebook')}}</span>
            </a>
          </li>
          <li>
            <a href="#" @click.prevent="copy">
              <i class="fa fa-link"/><span class="tooltip">{{$t('sharingModal.copy')}}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <toast ref="toastMessage">
    {{$t('sharingModal.linkCopied')}}
  </toast>
</template>
<script lang="ts">
import {defineComponent, type PropType} from "vue";
import type {ShowPublicObject} from "~/api/generated";
import Toast from "~/components/Toast.vue";
import config from '../config/config.json'

export default defineComponent({
  name: 'SharingModal',
  components: {Toast},
  props: {
    show: Object as PropType<ShowPublicObject>
  },
  data() {
    return {
      modalVisible: false
    }
  },
  computed: {
    pathUrl() {
      const route = useRoute();
      return `${config.BASE_URL}${route.fullPath}`
    },
    whatsappUrl() {
      const whatsAppApi = 'https://api.whatsapp.com/send?text='
      const encodedMessage = encodeURIComponent(`Comprá tus entradas para ${this.show?.name} en ${this.pathUrl}`);
      return `${whatsAppApi}${encodedMessage}`
    },
    facebookUrl() {
      const facebookUrl = 'http://www.facebook.com/sharer/sharer.php?u='
      return `${facebookUrl}${this.pathUrl}`
    },
    xUrl() {
      const xUrl = 'https://twitter.com/intent/tweet?text='
      const encodedMessage = encodeURIComponent(`Comprá tus entradas para ${this.show?.name}&url=${this.pathUrl}`);
      return `${xUrl}${encodedMessage}`
    }
  },
  methods: {
    closeModal() {
      this.modalVisible = false
    },
    openModal() {
      this.modalVisible = true
    },
    copy() {
      navigator.clipboard.writeText(this.pathUrl ?? '')
      this.$refs.toastMessage.activate(1.5)
      this.modalVisible = false
    }
  }
});
</script>